export default {
  API_URL: 'https://everoenergy-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://everoenergysandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
